<template>
  <div>
    <div
      style="
        border-bottom: 1px solid rgba(155, 155, 155, 0.25);
        margin-bottom: 20px;
      "
    >
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="报表名称">
          <el-select v-model="formInline.code" clearable placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="onSubmit"
            class="bg5584FF formBotton"
            >查询</el-button
          >
          <el-button type="info" @click="reset" class="formBotton"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <el-table
      border
      :data="tableData"
      stripe
      style="width: 100%"
      :header-cell-style="{ backgroundColor: '#DCDFE6', color: '#000' }"
      v-loading="loading"
    >
      <el-table-column type="index" width="50" fixed> </el-table-column>
      <el-table-column prop="name" label="报表名称" fixed>
        <template slot-scope="scope">
          <span class="detail" @click="handleDetail(scope.row)">{{
            scope.row.name
          }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="report_cycle" label="填报周期" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.report_cycle == 0">月报</span>
          <span v-else-if="scope.row.report_cycle == 1">季报</span>
          <span v-else-if="scope.row.report_cycle == 2">半年报</span>
          <span v-else>年报</span>
        </template>
      </el-table-column>
      <el-table-column prop="date_range" label="填报期" align="center">
        <template slot-scope="scope">
          <span>{{ getDateRange(scope.row) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="date_range_end"
        label="填表截止日"
        align="center"
      ></el-table-column>
      <el-table-column prop="crt_time" label="填表日期" align="center">
        <template slot-scope="scope">
          <span>{{
            $moment(scope.row.crt_time).format("YYYY-MM-DD HH:mm:ss")
          }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.status == 0">未填写</span>
          <span v-else-if="scope.row.status == 1">草稿</span>
          <span v-else-if="scope.row.status == 2">已过期</span>
          <span v-else-if="scope.row.status == 3">未审核</span>
          <span v-else-if="scope.row.status == 4">审核通过</span>
          <span v-else-if="scope.row.status == 5">审核不通过</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="100">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            :disabled="scope.row.status == 2"
            @click="edit(scope.row)"
            >修改
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pageBox">
      <el-pagination
        class="pagePC"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="20"
        layout="total,  prev, pager, next"
        :total="total"
      >
      </el-pagination>
      <van-pagination
        class="pagePhone"
        v-model="currentPage"
        :total-items="total"
        :items-per-page="20"
        :show-page-size="3"
        @change="changePage"
        force-ellipses
      />
    </div>
    <el-dialog
      v-if="editDialogVisible"
      title="编辑"
      :visible.sync="editDialogVisible"
      class="dialog770 titleChange"
      :width="screenWidth < 1200 ? '94%' : '1160px'"
      :close-on-click-modal="false"
      :destroy-on-close="true"
    >
      <zdquczb
        v-if="editCode == '001'"
        :id="editId"
        :report_yidong="report_yidong"
        @clos="clos"
      ></zdquczb>
      <zdjcqycwb
        v-if="editCode == '002'"
        :id="editId"
        :report_yidong="report_yidong"
        @clos="clos"
      ></zdjcqycwb>
      <gyyqjbqkb
        v-if="editCode == '003'"
        :id="editId"
        :report_yidong="report_yidong"
        @clos="clos"
      ></gyyqjbqkb>
    </el-dialog>
    <el-dialog
      v-if="showDialogVisible"
      title="查看"
      :visible.sync="showDialogVisible"
      class="dialog770 titleChange"
      :width="screenWidth < 1200 ? '94%' : '1160px'"
      :close-on-click-modal="false"
      :destroy-on-close="true"
    >
      <zdquczbShow
        v-if="editCode == '001'"
        :id="editId"
        :report_yidong="report_yidong"
      ></zdquczbShow>
      <zdjcqycwbShow
        v-if="editCode == '002'"
        :id="editId"
        :report_yidong="report_yidong"
      ></zdjcqycwbShow>
      <gyyqjbqkbShow
        v-if="editCode == '003'"
        :id="editId"
        :report_yidong="report_yidong"
      ></gyyqjbqkbShow>
    </el-dialog>
  </div>
</template>

<script>
import zdquczb from "./zdquczb/index";
import zdquczbShow from "./zdquczbShow/index";
import zdjcqycwb from "./zdjcqycwb/index";
import zdjcqycwbShow from "./zdjcqycwbShow/index";
import gyyqjbqkb from "./gyyqjbqkb/index";
import gyyqjbqkbShow from "./gyyqjbqkbShow/index";

export default {
  name: "index",
  components: {
    zdquczb,
    zdquczbShow,
    zdjcqycwb,
    zdjcqycwbShow,
    gyyqjbqkb,
    gyyqjbqkbShow,
  },
  data() {
    return {
      screenWidth: document.body.clientWidth, // 屏幕宽
      screeHeight: document.body.clientHeight, // 屏幕高
      options: [],
      pageSize: 20,
      showDialogVisible: false,
      tableData: [],
      pageNum: 1,
      total: 0, //表格总数
      loading: false,
      currentPage: 1,
      formInline: {
        //查询对象
        code: "",
      },
      editDialogVisible: false,
      editCode: "001",

      editId: "",
      report_yidong: 1,
    };
  },
  methods: {
    getDateRange(row) {
      const month = Number(row.date_range.split("-")[1]);
      const year = Number(row.date_range.split("-")[0]);
      if (row.report_cycle == 0) {
        //月报
        return row.date_range;
      } else if (row.report_cycle == 1) {
        //季报
        if (month <= 3) {
          return `${year}年第一季度`;
        } else if (month >= 4 && month <= 6) {
          return `${year}年第二季度`;
        } else if (month >= 7 && month <= 9) {
          return `${year}年第三季度`;
        } else {
          return `${year}年第四季度`;
        }
      } else if (row.report_cycle == 2) {
        //半年报
        if (month <= 6) {
          return `${year}年上半年`;
        } else {
          return `${year}年下半年`;
        }
      } else {
        //年报
        return `${year}年`;
      }
    },
    clos() {
      this.editDialogVisible = false;
      this.getdata(1);
    },
    getdata(pageNum) {
      this.loading = true;
      this.$axios
        .get("/business/data-insert/not-insert/page", {
          params: {
            pageNum: pageNum,
            pageSize: this.pageSize,
            code: this.formInline.code,
          },
        })
        .then((res) => {
          this.loading = false;
          this.tableData = res.data;
          this.total = res.total;
        })
        .catch((error) => {
          this.loading = false;
          console.log(error);
        });
    },
    initSelect() {
      this.loading = true;
      this.$axios
        .get("/business/data-insert/report-select")
        .then((res) => {
          this.loading = false;
          this.options = res.data;
          console.log(res);
        })
        .catch((error) => {
          this.loading = false;
          console.log(error);
        });
    },
    edit(row) {
      this.editCode = row.code;
      this.editId = row.id;
      this.report_yidong = row.report_yidong;
      this.editDialogVisible = true;
      console.log(row);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getdata(1);
    },
    handleDetail(row) {
      this.editId = row.id;
      this.editCode = row.code;
      this.report_yidong = row.report_yidong;
      this.showDialogVisible = true;
    },
    changePage() {
      this.pageNum = this.currentPage;
      this.getdata(this.currentPage);
    },
    handleCurrentChange(val) {
      //跳转页
      this.getdata(val);
    },
    onSubmit() {
      this.getdata(1);
    },
    reset() {
      this.formInline = {
        code: "",
      };
      this.getdata(1);
    },
  },
  created() {
    this.getdata(1);
    this.initSelect();
  },
  mounted() {
    window.onresize = () => {
      this.screenWidth = document.body.clientWidth;
    };
  },
};
</script>

<style scoped>
.detail {
  width: 100%;
  height: 100%;
  cursor: pointer;
  color: #5584ff;
}

.handsontableInput {
  box-shadow: 0 0 0 0 #f6f7f8 inset;
  padding: 0px;
}
.pagePhone {
  display: none;
}

@media (max-width: 1200px) {
  .pagePC {
    display: none;
  }
  .pagePhone {
    display: flex;
  }
  .phone_btn_margin {
    margin-left: 0 !important;
    margin-top: 4px;
  }
}
</style>